/*
 * LightBox 1.0
 * Copyright (c) 2015 小坏 http://tnnyang.cnblogs.com
 * 仅用于PC端
 * 图片放大以后还可以左右切换
 */

define(function(require, exports, module){


    var $ = require('jquery');


    function imgobj(obj1, obj2){
        //imgObj.height是通过img对象获取的图片的实际高度
        var imgObj = new Image();
        imgObj.src = obj1.attr("src");

        var body = $('body'), width = imgObj.width, height = imgObj.height, margintop;
        //如果图片宽高小于浏览器宽高
        if(height < body.height() * 0.95 && width < body.width() * 0.95){
            margintop = 0 - (height)/2;
        }else if(width/height < body.width()/body.height()){    //如果图片宽高比小于浏览器宽高比
            height = body.height() * 0.95;
            width = imgObj.width * height / imgObj.height;
            margintop = 0 - (height)/2;
        }else{
            width = body.width() * 0.95;
            height = imgObj.height * width / imgObj.width;
            margintop = 0 - height/2;
        }
        obj2.css("margin-top", margintop);
        obj1.attr("width", width);
        obj1.attr("height", height);
    }


    var numpic = 0, num = 0;


    return {
        //初始化PC图片大图查看 创建一个div
        init: function(){
            var lb_wrap = '<div class="lb_wrap"><div class="lightbox_bg"></div><div class="lightbox"><img src="" class="lg_img"></div></div>';
            $("body").append(lb_wrap);

            $(".lightbox").append('<p class="prev"></p><p class="next"></p>');
        },


        /**
         * 查看大图
         * @param {String} imgs 图片数组
         * @param {String} index 当前放大图片索引
         */
        show: function(imgs, index){
            //显示图片
            numpic = imgs.length;
            num = index;   //获取当前图片的父元素的索引并赋给num为后边点击上一张、下一张服务

            var src = imgs[index];
            $(".lg_img").attr("src",src);
            imgobj($(".lg_img"), $(".lightbox"));

            $(".lb_wrap").fadeIn();
            $(".lg_img").fadeIn();
            $(".prev").fadeIn().siblings(".next").fadeIn();

            //上一张
            $(".prev").click(function(){
                if(num == 0){
                    num = numpic;
                }
                var src = imgs[num-1];
                $(".lg_img").attr("src",src);
                imgobj($(".lg_img"), $(".lightbox"));

                num--;
            });

            //下一张
            $(".next").click(function(){
                if(num == numpic-1){
                    num = -1;
                }
                var src = imgs[num+1];
                $(".lg_img").attr("src",src);
                imgobj($(".lg_img"), $(".lightbox"));

                num++;
            });

            //点击除了上一张、下一张之外的其他地方隐藏
            $(".lb_wrap").click(function(e){
                var e = e || window.event;
                var elem = e.target || e.srcElement;
                while(elem){
                    if (elem.className && elem.className.indexOf('prev')>-1) {
                        return;
                    }
                    if(elem.className && elem.className.indexOf('next')>-1){
                        return;
                    }
                    elem = elem.parentNode;
                }
                $(this).find("img").attr("src","loading.gif").hide();      //隐藏后，再将默认的图片赋给lightbox中图片的src
                $(this).find(".prev").hide().siblings(".next").hide();
                $(this).fadeOut();
            });

        }
    };

});


// WEBPACK FOOTER //
// ./modules/piczoom/0.0.0/piczoom.js